import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles, Dialog, DialogTitle } from '@material-ui/core';
import { Close } from '@material-ui/icons';

import { Button, DialogContent } from '@redshelf/redshelf-ui';
import { Typography } from '@redshelf/redshelf-ui';

import IconButton from 'components/IconButton';
import { SCREEN_SIZE_CATEGORIES, STATIC_PATH } from 'constants';
import {
  UserContentItemModifiersContext,
  ViewportValuesContext,
} from 'contexts';

const useStyles = makeStyles((theme) => ({
  owliverImg: {
    position: 'absolute',
    right: theme.spacing(1.75),
    bottom: 0,
  },
  tryAgainButton: {
    marginTop: theme.spacing(3),
  },
  closeButton: {
    alignSelf: 'flex-end',
    margin: theme.spacing(1, 1, 0),
  },
}));

const StyledDialogTitle = withStyles((theme) => ({
  root: {
    color: theme.palette.greyBlue[700],
    display: 'flex',
    paddingTop: 0,
  },
}))(DialogTitle);

const StyledDialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(1, 3, 2),
    overflowY: 'visible',
    marginBottom: theme.spacing(24),
  },
  [theme.breakpoints.down('xs')]: {
    root: {
      marginBottom: theme.spacing(19),
    },
  },
}))(DialogContent);

const ErrorDialog = ({
  ariaLabel,
  buttonAction = () => {},
  buttonText,
  closeAction = () => {},
  description,
  open,
  title,
  ...props
}) => {
  const classes = useStyles();
  const { viewport } = useContext(ViewportValuesContext);
  const { onDialogClose, onDialogOpen } = useContext(
    UserContentItemModifiersContext,
  );
  const shouldShowFullscreen =
    viewport.widthCategory <= SCREEN_SIZE_CATEGORIES.PHONE;

  const [isOpen, setIsOpen] = useState(open);

  const onClose = () => {
    closeAction();
    setIsOpen(false);
    onDialogClose('errorDialog');
  };

  const handleButtonAction = () => {
    buttonAction();
    onDialogClose('errorDialog');
  };

  return (
    <Dialog
      aria-label={ariaLabel}
      aria-labelledby="error-msg"
      maxWidth="xs"
      className={classes.root}
      open={isOpen}
      fullScreen={shouldShowFullscreen}
      onClose={(_, reason) => {
        if (reason !== 'escapeKeyDown') {
          onClose();
        }
      }}
      // add close on Escape Key Up
      onKeyUp={(e) => {
        e.stopPropagation();
        if (e.key === 'Escape') {
          onClose();
        }
      }}
      TransitionProps={{ onEnter: () => onDialogOpen('errorDialog') }}
      {...props}
    >
      <IconButton
        aria-label="Close"
        className={classes.closeButton}
        onClick={onClose}
      >
        <Close />
      </IconButton>
      <StyledDialogTitle>
        <Typography variant="h3" component="span">
          {title}
        </Typography>
      </StyledDialogTitle>

      <StyledDialogContent>
        <Typography variant="body1" id="error-msg">
          {description}
        </Typography>
        {buttonText && (
          <Button
            className={classes.tryAgainButton}
            onClick={handleButtonAction}
          >
            {buttonText}
          </Button>
        )}
      </StyledDialogContent>

      <img
        alt=""
        src={`${STATIC_PATH}/images/owl.svg`}
        className={classes.owliverImg}
      />
    </Dialog>
  );
};

ErrorDialog.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  buttonAction: PropTypes.func,
  buttonText: PropTypes.string,
  closeAction: PropTypes.func,
  description: PropTypes.string,
  open: PropTypes.bool,
  title: PropTypes.string,
};

export default ErrorDialog;
